<div class="p-modal-foot01">
  <button
    id="passenger-information-request-footer-button1"
    class="c-btn-primary c-btn-primary--s c-btn-primary--min-w100"
    aswThrottleClick
    (throttleClick$)="clickApply()"
  >
    <!--パーツ(16)：更新-->
    <span class="c-btn-primary__text" [innerHTML]="'label.change.button' | staticMsg"></span>
  </button>
</div>
